import { render, staticRenderFns } from "./ShareUser.vue?vue&type=template&id=241e5d52&"
import script from "./ShareUser.vue?vue&type=script&lang=ts&"
export * from "./ShareUser.vue?vue&type=script&lang=ts&"
import style0 from "./ShareUser.vue?vue&type=style&index=0&id=241e5d52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports